import type { Token } from "./types";

export function TokenList({
  tokens,
}: {
  tokens: Token[];
}) {
  const COLORS = [
    "aliceblue",
    "antiquewhite",
    "azure",
    "cornsilk",
    "floralwhite",
    "honeydew",
    "lavender",
    "lavenderblush",
    "lightcyan",
    "mintcream",
    "oldlace",
    "papayawhip",
    "peachpuff",
    "seashell",
  ];

  const colorFor = (index: number) => {
    return COLORS[index % COLORS.length];
  };

  return (
    <>
      {(tokens || []).map(([id, token], index) => (
        <span
          key={`input-token-${index}`}
          title={`${id}`}
          style={{ background: colorFor(index) }}
        >
          {token}
          {id === 13 ? <br /> : ""}
        </span>
      ))}
    </>
  );
}
